module.exports = __webpack_public_path__ + "static/media/tests-preview.ff167670.png";